/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import bgImg from "../../Assets/imgNewUI/topoffer/bgImg.jpg";
import filter from "../../Assets/imgNewUI/filter2.svg";
import SelectedBrand from "../../Components/SelectedBrand/SelectedBrand";
import FilterModal from "../../Components/FilterModal/FilterModal";
import ScrollToTop from "../../Utility/ScrollToTop/ScrollToTop";
import CouponModal from "../../Components/CouponModal/CouponModal";
import { useDispatch, useSelector } from "react-redux";
import {
  ApiConfigData,
  ApplyThemeStyles,
  ClientPlatformCode,
  DefaultCardName,
  Login,
  OfferSectionContentMasterData,
  OfferSectionMasterData,
  SectionContentMasterData,
  SectionMasterDataBySectionId,
  ShouldShowSection,
  ThemeData,
  trackEvent,
  UserIdAndStatusData,
  UtilityReducer,
  ValidateLoginToken,
} from "../../Utility/Utility";
import OfferLoader from "../../Utility/Loader/offerLoader.js";
import NoRecord from "../../Components/NoRecord/NoRecord";
import CommonWebOffer from "../../Components/CommonWebOffer/CommonWebOffer";
import { decryptAES, encryptAES } from "../../Common/Axios/encrypt";
import CommonMobileOffer from "../../Components/CommonMobileOffer/CommonMobileOffer";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import WebTopOfferBanner from "../../WebComponents/WebTopOfferBanner/WebTopOfferBanner";
import { GetOfferData } from "../../Store/Slices/dealsDataSlice.js";
import CardLoader from "../../Utility/Loader/CardLoader.js";
import { Helmet } from "react-helmet";
import { dataFromDealPage } from "../../Store/Slices/utilityReducer.js";
import searchIcon from "../../Assets/img/search.svg";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader.js";
import TopOfferBanner from "../../Components/TopOfferBanner/TopOfferBanner.jsx";
import { onLandingHome } from "../../Store/Slices/homePageLandingSlice.js";
import "../../Components/Tabs/tabs.scss";
import CommonOffer from "../../Components/CommonWebOffer/CommonOffer.js";
import OfferTabFilters from "../../Components/OfferTabFilters/index.jsx";

const TopOfferPage = ({
  // Filter dealData based on netFilterDealCoupons
  isModalOpenoffer,
  setIsModalOpenoffer,
  isMobileView,
  setShowModal,
  setIsLoading,
}) => {
  const hasFetchedRef = useRef(false);
  const observerLockRef = useRef(false);
  const location = useLocation();
  const translation = getTranslation();
  const [dealsData, setDealsData] = useState({
    dealCoupon: [],
    deal: null,
  });
  const dispatch = useDispatch();
  const token = ValidateLoginToken();
  // Context Data from Utility.js
  const [dealData, setDealData] = useState();
  const [dealCouponData, setDealCoupon] = useState();
  const [dealCategoryData, setDealCategory] = useState();
  const [, setDealFreq] = useState();
  const [dealsFilter, setDealFilter] = useState();
  const { isLoading } = OfferSectionContentMasterData();
  const { clientCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();
  const apiconfig = ApiConfigData();
  const categoryDefaultIcon = apiconfig?.find(
    (data) => data?.paramsKey === "CategoryDefaultIcon"
  )?.paramsValue;
  const { sctionContentdata } = SectionContentMasterData();
  const { isSectionLoading, sectionMasterData } = OfferSectionMasterData(Login);

  const themeData = ThemeData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const stid = queryParams.get("stid")?.replace(/\s/g, "+");
  const ctid = queryParams.get("ctid")?.replace(/\s/g, "+");
  const categoryId = ctid && decryptAES(ctid);
  const sectionId = stid && decryptAES(stid);
  const [activeTab, setActiveTab] = useState("Validity");
  const validityFilters = queryParams.getAll("validity") || [];
  const categoryFilters = queryParams.getAll("category") || [];
  const brandFilters = queryParams.getAll("brand") || [];
  const offerFilters = queryParams.getAll("offer") || [];
  const searchFilters = queryParams.getAll("search") || [];
  const focusSearchParam = queryParams.get("focusSearch") === "true";
  const offerParamFromUrl = queryParams.get("offer") || "";
  const sourceTypeParam = queryParams.get("sourceType") || "";
  const sourceValueParam = queryParams.get("sourceValue") || "";
  const hasSourceParams =
    sourceTypeParam !== null &&
    sourceTypeParam !== undefined &&
    String(sourceTypeParam).trim() !== "" &&
    sourceValueParam !== null &&
    sourceValueParam !== undefined &&
    String(sourceValueParam).trim() !== "";
  const clientMasterData = useSelector((state) => state.clientMasterReducer);
  const clientData = clientMasterData?.clientMasterData || [];
  const clientcode = clientData?.[0]?.clientCode || "";
  const initialFilters = {
    validity: validityFilters,
    category: hasSourceParams ? [] : categoryFilters,
    brand: brandFilters,
    offer: offerFilters,
  };
  const login = sessionStorage.getItem("login");
  const [appliedFilters, setAppliedFilters] = useState(categoryId ? { ...initialFilters, category: [String(categoryId)] } : initialFilters);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(20);
  const [searchLoader, setSearchLoader] = useState(false);
  const [comLoader, setCompLoader] = useState(false);
  const [, setTotalRecord] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(true);
  // Ref for the loader div
  const loaderRef = useRef(null);
  const searchInputRef = useRef(null);
  const hasAppliedFocusSearchRef = useRef(false);
  // Set by the tab-resolving effect when it settles activeCate/active, on first mount, to a tab
  // that only mirrors a filter already applied by the very first fetch (see that effect's own
  // comment for why) — the main fetch effect below reads and clears it to skip the otherwise
  // redundant re-fetch of data it already has.
  const skipNextFetchForDefaultTabRef = useRef(false);
  const [isFocused, setIsFocused] = useState(false);
  const [searchText, setSearchText] = useState(searchFilters[0] || "");
  const prevSearchTextRef = useRef(searchText);
  const [activeCate, setActiveCate] = useState();
  const [active, setActive] = useState("");
  const [dealCategoryTabData, setDealCategoryTabData] = useState();
  const tabBarRef = useRef(null);
  const backBtnRef = useRef();
  const [isSupportBanner, setIsSupportBanner] = useState(false);
  const sectionData = SectionMasterDataBySectionId(Login, sectionId).sectionMasterData;
  const [temporaryFilters, setTemporaryFilters] = useState(categoryId ? { ...appliedFilters, category: [String(categoryId)] } : appliedFilters);
  const [tagFilters, setTagFilters] = useState(categoryId ? { ...initialFilters, category: [String(categoryId)] } : initialFilters);
  const cards = UtilityReducer();
  const creditCards = cards?.creditCards;
  const { filteredDays, filteredByOfferSubType, filteredDealCategories, filteredDeals } = useSelector((state) => state?.dealsDataSlice?.allofferData);
  const offerTabFilterTabs = (filteredByOfferSubType || []).map((item) => ({
    key: item?.key,
    label: item?.value,
  }));
  const filterIconUrl = `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientcode}/filter.svg`
  const navigate = useNavigate();
  // Set default CSS variable on mount to prevent tab underline timing issues
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--themeconfigurationCategoryTextColor",
      "#222222"
    );
  }, []);

  // Arriving from a search entry point (e.g. FeaturedOffer's search tab) — focus the
  // search bar, then drop the param so it doesn't linger in the URL. Gated on the same
  // loading flags that guard the real content below (OfferLoader renders in their place
  // until then), so this doesn't fire while the search input hasn't mounted yet — and
  // guarded by a ref so it only ever runs once, since isFetching flips again on every
  // later filter change.
  useEffect(() => {
    if (!focusSearchParam || hasAppliedFocusSearchRef.current) return;
    if (isLoading || isSectionLoading || isFetching) return;
    hasAppliedFocusSearchRef.current = true;
    searchInputRef.current?.focus();
    setTimeout(() => {
      // searchInputRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
      const rect = searchInputRef.current.getBoundingClientRect();
      window.scrollTo({
        top: (rect.top + window.scrollY) - 10, // or window.pageYOffset, same value
        left: 0,
        behavior: 'smooth',
      });
    }, 500);
    const url = new URL(window.location.href);
    url.searchParams.delete("focusSearch");
    navigate(`${url.pathname}${url.search}`, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSectionLoading, isFetching]);

  useEffect(() => {
    ApplyThemeStyles(themeData);
    // Update CSS variable when theme loads
    if (themeData) {
      document.documentElement.style.setProperty(
        "--themeconfigurationCategoryTextColor",
        themeData?.categoryTextColor || themeData?.commonElementTextColor || "#222222"
      );
    }
  }, [themeData]);

  // Add a filtering state to block observer during filter changes
  const [filtering, setFiltering] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isFilterFlowActive, setIsFilterFlowActive] = useState(false);
  const offerSubTypeLabel = translation?.offerSubType || "Offer Sub-Type";

  const getTabCategoryValue = (tab) => {
    const tabName = String(tab?.name || tab?.value || "").trim().toLowerCase();
    if (tabName === "all") return "all";
    return String(tab?.key);
  };

  const tabCategoryValues = new Set((dealCategoryTabData || []).map((tab) => getTabCategoryValue(tab)));
  const visibleCategoryTagFilters = (tagFilters?.category || []).filter((categoryKey) => {
    if (String(categoryKey) === "all") return false;
    if (isFilterFlowActive) return true;
    return !tabCategoryValues.has(String(categoryKey));
  });
  const visibleCategoryAppliedFilters = (appliedFilters?.category || []).filter((categoryKey) => {
    if (String(categoryKey) === "all") return false;
    if (isFilterFlowActive) return true;
    return !tabCategoryValues.has(String(categoryKey));
  });
  const visibleTagFilters = {
    ...tagFilters,
    category: visibleCategoryTagFilters,
  };
  const hiddenCategoryChipValues = isFilterFlowActive
    ? []
    : Array.from(tabCategoryValues).filter((categoryKey) => String(categoryKey) !== "all");

  const applyFilter = (filters, dontCallGA) => {
    const resolvedFilters = filters;

    const hasAnyFilter = Object.values(resolvedFilters || {}).some((value) =>
      Array.isArray(value) ? value.length > 0 : !!value
    );
    setIsFilterFlowActive(hasAnyFilter);
    setActive(''); // Reset active category on filter change
    setActiveCate(null); // Reset active category on filter change
    setFiltering(true); // Always set filtering true on any filter change
    setSearchLoader(true); // Show the skeleton loader while the refetch is in flight
    setTagFilters(resolvedFilters);
    setAppliedFilters(resolvedFilters);
    setPageNo(1);
    setIsModalOpen(false);
    hasFetchedRef.current = false; // Reset API call flag on filter change/clear

    // Remove 'ctid' from URL and reset URL to base path (without search params)
    const url = new URL(window.location.href);
    if (url.searchParams.has('ctid')) {
      url.searchParams.delete('ctid');
    }
    // Remove all search params if filters are cleared (no filters applied)
    const noFilters = !Object.values(resolvedFilters || {}).some(arr => Array.isArray(arr) ? arr.length > 0 : !!arr);
    if (noFilters && !!activeCate) {
      window.history.replaceState({}, '', url.pathname);
    } else {
      window.history.replaceState({}, '', url.toString());
    }

    const filterPayload = {
      filteredDays,
      filteredByOfferSubType,
      filteredDealCategories,
      filteredDeals,
      filters: resolvedFilters
    };
    if (!dontCallGA) {
      let selected = buildFilterString(filterPayload);
      trackEvent("filter_applied", {
        section_title: sectionId ? sectionData[0]?.sectionName : "Offers",
        applied_value: selected === "Category-NA" ? "NA" : selected,
        cta_text: selected === "Category-NA" ? "Clear Filter" : "Apply",
        page_type: window.location.pathname?.split("/")?.[1],
        client_code: clientCode,
        platform_code: platformCode,
        user_id: userId,
        user_status: userStatus,
        card_name: defaultCardName
      });
    }
  }

  // Keeps the OfferTabFilters scroller and the FilterModal's "Offer" checkboxes in sync.
  // applyFilter updates appliedFilters/tagFilters (covers tab -> count/active-pill and
  // modal Apply -> tab). FilterModal itself bootstraps its checkboxes purely from the URL
  // on open (see its getFiltersFromURL), so the "offer" query param is synced here too —
  // otherwise a tab-driven change would be invisible the next time the modal is opened.
  // Clicking an already-active tab removes it (clears that filter) instead of no-op-ing.
  const handleOfferTabClick = (tab) => {
    const tabKey = String(tab?.key ?? tab?.value ?? "");
    if (!tabKey) return;
    const currentOffer = appliedFilters?.offer || [];
    const nextOffer = currentOffer.includes(tabKey)
      ? currentOffer.filter((value) => value !== tabKey)
      : [...currentOffer, tabKey];
    applyFilter({ ...appliedFilters, offer: nextOffer });

    const url = new URL(window.location.href);
    url.searchParams.delete("offer");
    nextOffer.forEach((value) => url.searchParams.append("offer", value));
    window.history.replaceState({}, "", url.toString());
  };

  function buildFilterString(data) {
    if (!data) return "";
    const parts = [];
    // VALIDITY
    if (data?.filters?.validity?.length) {
      const validityMap = Object.fromEntries(
        data?.filteredDays?.map(v => [String(v.key), v.value])
      );
      const validityValues = data?.filters?.validity
        .map(v => validityMap[v])
        .filter(Boolean);
      if (validityValues.length) {
        parts.push(`Validity-${validityValues.join(", ")}`);
      }
    }

    // CATEGORY
    if (data?.filters?.category?.length) {
      const categoryMap = Object.fromEntries(
        data?.filteredDealCategories?.map(c => [String(c.id), c.name])
      );
      let categoryValues = [];
      if (data?.filters?.category.includes("all") && data?.filters?.category?.length === 1) {
        categoryValues.push("NA");
      }
      data?.filters?.category.forEach(c => {
        if (c !== "all" && categoryMap[c]) {
          categoryValues.push(categoryMap[c]);
        }
      });
      if (categoryValues?.length) {
        parts.push(`Category-${categoryValues.join(",")}`);
      }
    } else {
      let categoryValues = [];
      if (data?.filters?.category?.length === 0 && !sectionId) {
        categoryValues.push("NA");
      }
      if (categoryValues?.length) {
        parts.push(`Category-${categoryValues.join(",")}`);
      }
    }

    // BRAND
    if (data?.filters?.brand?.length) {
      const brandMap = Object.fromEntries(
        data?.filteredDeals?.map(b => [String(b.key), b.value])
      );
      const brandValues = data?.filters?.brand
        .map(b => brandMap[b])
        .filter(Boolean);
      if (brandValues.length) {
        parts.push(`Brand-${brandValues.join(",")}`);
      }
    }

    // OFFER
    if (data?.filters?.offer?.length) {
      parts?.push(`Offer-${data?.filters?.offer.join(",")}`);
    }

    return parts?.join("|");
  }

  const loginAuthData = useSelector((state) => state.loginAuthReducer);

  // IntersectionObserver callback
  const handleObserver = useCallback(
    (entries) => {
      if (filtering || comLoader || searchLoader || observerLockRef.current || !hasMore) return;
      const target = entries[0];
      if (target.isIntersecting) {
        observerLockRef.current = true;
        setCompLoader(true);
        setPageNo((prev) => prev + 1);
      }
    },
    [comLoader, hasMore, filtering, searchLoader]
  );

  const categoryList = ['Travel', 'Shopping', 'Food', 'Grocery', 'Entertainment', 'Electronics', 'Others'];
  const findCategoryList = (filteredCategories, categoryList) => {
    return filteredCategories?.filter(category =>
      categoryList.some(filtered => filtered?.toLowerCase() === category?.name.toLowerCase())
    ).map(category => ({
      key: category.id,
      value: category.name,
      mobImage: category.mobImage,
      webImage: category.webImage,
    }));
  }

  const getContentCategoryListForTab = (filteredCategories) => {
    const offerPageCategories = filteredCategories?.filter(x => x.isOfferpage) || [];
    let isImageAvailable = false;
    isImageAvailable = offerPageCategories.some(category => category.webImage);
    return offerPageCategories
      .sort((firstCategory, secondCategory) => {
        const firstDisplayOrder = Number(firstCategory?.displayOrder);
        const secondDisplayOrder = Number(secondCategory?.displayOrder);
        const normalizedFirstOrder = Number.isFinite(firstDisplayOrder) ? firstDisplayOrder : Number.MAX_SAFE_INTEGER;
        const normalizedSecondOrder = Number.isFinite(secondDisplayOrder) ? secondDisplayOrder : Number.MAX_SAFE_INTEGER;
        return normalizedFirstOrder - normalizedSecondOrder;
      })
      .map(category => ({
        key: category.id,
        value: category.displayName,
        name: category.name,
        mobImage: isImageAvailable ? category.mobImage || category.webImage || categoryDefaultIcon : "",
        webImage: isImageAvailable ? category.webImage || categoryDefaultIcon : "",
        isDefaultTab: category.isDefaultTab ?? category.isDefaultCategory ?? false,
        contentSourceType: category.contentSourceType,
        sourceValue: category.sourceValue
      }));
  }
  useEffect(() => {
    if (!dealCategoryTabData?.length) return;

    if (isFilterFlowActive) {
      if (active !== "") setActive("");
      if (activeCate !== null && activeCate !== undefined) setActiveCate(null);
      return;
    }

    // Whether this is the very first time a tab is being resolved (mount settle, before the
    // user or any later effect has touched activeCate/active). Below, Cases 1/3/4 only ever
    // resolve a tab that mirrors a filter (appliedFilters.category, offerParamFromUrl or
    // sourceType/sourceValue) the main fetch effect already reads directly off the URL/state
    // and applies on its very first call, before dealCategoryTabData even exists — so on first
    // settle, picking that same tab here is pure UI sync, not a reason to fetch again. Case 2
    // only matches once activeCate/active already hold a value, so it can't be a first settle.
    // Case 5's fallback is the one exception: a non-"all" default tab introduces a filter the
    // first (unfiltered) fetch never applied, and genuinely needs its own fetch.
    const isInitialSettle = activeCate === undefined && active === "";

    // 🔹 Case 1: Chips selected → tab follow chips
    if (appliedFilters.category.length > 0) {
      const activeCategory = dealCategoryTabData.find(tab =>
        appliedFilters.category.includes(getTabCategoryValue(tab))
      );

      if (activeCategory) {
        if (isInitialSettle) skipNextFetchForDefaultTabRef.current = true;
        setActive(activeCategory.value);
        setActiveCate(activeCategory.key);
      }
      return;
    }

    // 🔹 Case 2: Keep already selected tab (prevents fallback overriding on click)
    const stateSelectedTab =
      dealCategoryTabData.find((tab) => String(tab?.key) === String(activeCate)) ||
      dealCategoryTabData.find((tab) => tab?.value === active);

    if (stateSelectedTab) {
      if (active !== stateSelectedTab.value) setActive(stateSelectedTab.value);
      if (String(activeCate) !== String(stateSelectedTab.key)) setActiveCate(stateSelectedTab.key);
      return;
    }

    // 🔹 Case 3: Restore Offer Sub-Type tab from `offer` URL param on refresh/navigation
    if (offerParamFromUrl) {
      const offerTab = dealCategoryTabData.find(
        (tab) =>
          tab?.contentSourceType === offerSubTypeLabel &&
          String(tab?.sourceValue).toLowerCase() === String(offerParamFromUrl).toLowerCase()
      );

      if (offerTab) {
        if (isInitialSettle) skipNextFetchForDefaultTabRef.current = true;
        setActive(offerTab.value);
        setActiveCate(offerTab.key);
        return;
      }
    }

    // 🔹 Case 4: Restore source-based tab from URL on refresh/navigation
    if (hasSourceParams) {
      const sourceTab = dealCategoryTabData.find(
        (tab) =>
          tab?.contentSourceType === sourceTypeParam &&
          String(tab?.sourceValue) === String(sourceValueParam)
      );

      if (sourceTab) {
        if (isInitialSettle) skipNextFetchForDefaultTabRef.current = true;
        setActive(sourceTab.value);
        setActiveCate(sourceTab.key);
        return;
      }
    }

    // 🔹 Case 5: No chips → default tab
    // const defaultTab = dealCategoryTabData.find(tab => tab.key === 'all');
    // Falls back to the "All" tab when the client config flags no default — a plain /deal visit
    // should still land on ?category=all rather than a bare URL.
    const defaultTab =
      dealCategoryTabData.find(tab => tab.isDefaultTab || tab.isDefaultCategory) ||
      dealCategoryTabData.find(tab => getTabCategoryValue(tab) === "all");
    if (!sectionId && defaultTab) {
      // Unlike cases 1/3/4 above, a non-"all" default tab introduces a filter the first
      // (unfiltered) fetch never applied, so it still needs its own fetch — only the "all"
      // no-op default is a pure UI sync like the others.
      if (isInitialSettle && getTabCategoryValue(defaultTab) === "all") {
        skipNextFetchForDefaultTabRef.current = true;
      }
      setActive(defaultTab.value);
      setActiveCate(defaultTab.key);
    }
  }, [dealCategoryTabData, appliedFilters.category, offerParamFromUrl, sourceTypeParam, sourceValueParam, hasSourceParams, sectionId, activeCate, active, offerSubTypeLabel, isFilterFlowActive]);

  // Based on Tab Selection Changes the URL Param and applied filters
  useEffect(() => {
    if (!dealCategoryTabData?.length) return;

    const selectedTab =
      dealCategoryTabData.find((tab) => String(tab?.key) === String(activeCate)) ||
      dealCategoryTabData.find((tab) => tab?.value === active);

    if (!selectedTab) return;

    const params = new URLSearchParams(window.location.search);

    const hasSelectedTabSource =
      selectedTab?.contentSourceType !== null &&
      selectedTab?.contentSourceType !== undefined &&
      String(selectedTab?.contentSourceType).trim() !== "" &&
      selectedTab?.sourceValue !== null &&
      selectedTab?.sourceValue !== undefined &&
      String(selectedTab?.sourceValue).trim() !== "";

    const isOfferSubTypeTab =
      hasSelectedTabSource &&
      selectedTab?.contentSourceType === offerSubTypeLabel;

    if (isOfferSubTypeTab) {
      params.delete("category");
      params.delete("sourceType");
      params.delete("sourceValue");
      params.set("offer", String(selectedTab?.sourceValue).toUpperCase());
    } else {
      params.delete("offer");
      params.set("category", getTabCategoryValue(selectedTab));

      if (hasSelectedTabSource) {
        params.set("sourceType", selectedTab.contentSourceType);
        params.set("sourceValue", String(selectedTab.sourceValue));
      } else {
        params.delete("sourceType");
        params.delete("sourceValue");
      }
    }

    const nextSearch = `?${params.toString()}`;
    if (nextSearch !== location.search) {
      navigate(`${location.pathname}${nextSearch}`, { replace: true });
    }
  }, [activeCate, active, dealCategoryTabData, location.pathname, location.search, navigate, offerSubTypeLabel]);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };
    const observer = new window.IntersectionObserver(handleObserver, option);
    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, [handleObserver]);

  useEffect(() => {
    if (sctionContentdata?.length === 0) {
      dispatch(onLandingHome());
    }
  }, []);

  useEffect(() => {
    if (backBtnRef.current === true) return; // skip logic if navigating away
    // The tab-resolving effect just settled activeCate/active, on first mount, to a tab that
    // only mirrors a filter this effect already applied on its own very first run — skip
    // re-fetching the exact same data a second time just to reflect that in the payload too.
    if (skipNextFetchForDefaultTabRef.current) {
      skipNextFetchForDefaultTabRef.current = false;
      return;
    }
    localStorage.setItem("appliedFilters", JSON.stringify(tagFilters));
    // Prevent API call if user navigated back to home (sessionStorage 'toTop' flag)
    if (sessionStorage.getItem("toTop")) {
      sessionStorage.removeItem("toTop");
      return;
    }
    // if (hasFetchedRef.current) return;
    if (token?.memberIdentifier || loginAuthData?.data || !loginAuthData) {
      // hasFetchedRef.current = true;
      if (loginAuthData?.isLoading) {
        setIsLoading(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
        return;
      }
      const cards = [...new Set(creditCards?.map(card => card.Network?.toLowerCase()).filter(Boolean))] || [];
      const cardCodeValue = [
        ...new Set(
          token?.otherListAttribute?.[0]?.valueDetails
            ?.filter(card => card.status === "1" || card.status === "2")
            ?.map(card => card.CardTypeName?.toLowerCase())
            .filter(Boolean)
        )
      ] || [];
      let payload = {
        pageNumber: pageNo,
        pageSize: pageSize,
        search: searchText,
        filters: appliedFilters,
      };

      if (token?.memberIdentifier) payload.memberIdentifier = token.memberIdentifier;
      if (token?.memberIdentifier && cards.length > 0) payload.cardsNetwork = cards;
      if (token?.memberIdentifier && token?.otherListAttribute[0]?.valueDetails?.length > 0) payload.cardCodeValue = cardCodeValue;
      if (sectionId) payload.sectionId = sectionId;

      const selectedTabData =
        dealCategoryTabData?.find((tab) => String(tab?.key) === String(activeCate)) ||
        dealCategoryTabData?.find((tab) => tab?.value === active);
      const defaultTabData = !sectionId
        ? dealCategoryTabData?.find((tab) => tab?.isDefaultTab || tab?.isDefaultCategory) ||
        dealCategoryTabData?.find((tab) => getTabCategoryValue(tab) === "all")
        : null;
      const effectiveSelectedTab = selectedTabData || defaultTabData;

      const hasSelectedTabSource =
        effectiveSelectedTab?.contentSourceType !== null &&
        effectiveSelectedTab?.contentSourceType !== undefined &&
        String(effectiveSelectedTab?.contentSourceType).trim() !== "" &&
        effectiveSelectedTab?.sourceValue !== null &&
        effectiveSelectedTab?.sourceValue !== undefined &&
        String(effectiveSelectedTab?.sourceValue).trim() !== "";

      if (effectiveSelectedTab && appliedFilters.category.length === 0) {
        if (hasSelectedTabSource) {
          payload.extraParams = {
            sourceType: effectiveSelectedTab.contentSourceType,
            sourceValue: effectiveSelectedTab.sourceValue
          };
          payload.filters = {
            ...payload.filters,
            category: (payload?.filters?.category || []).filter((categoryKey) => String(categoryKey) !== "0")
          };
        } else {
          payload.filters.category = [getTabCategoryValue(effectiveSelectedTab)];
        }
      } else if (hasSourceParams) {
        payload.extraParams = {
          sourceType: sourceTypeParam,
          sourceValue: sourceValueParam
        };
        payload.filters = {
          ...payload.filters,
          category: (payload?.filters?.category || []).filter((categoryKey) => String(categoryKey) !== "0")
        };
      } else if (offerParamFromUrl && appliedFilters.category.length === 0) {
        payload.extraParams = {
          sourceType: offerSubTypeLabel,
          sourceValue: offerParamFromUrl
        };
        payload.filters = {
          ...payload.filters,
          category: (payload?.filters?.category || []).filter((categoryKey) => String(categoryKey) !== "0")
        };
      }
      if (!searchLoader)
        setCompLoader(true);

      dispatch(GetOfferData(payload)).then((response) => {
        const cateGoryList = findCategoryList(response?.payload?.data?.response?.items[0]?.filteredDealCategories, categoryList) || [];
        const contentCateGoryList = getContentCategoryListForTab(response?.payload?.data?.response?.items[0]?.filteredDealCategories) || [];
        const newDeals = response?.payload?.data?.response?.items[0]?.deals || [];
        const newCoupons = response?.payload?.data?.response?.items[0]?.dealCoupouns || [];
        // Only set dealCategoryData if it doesn't already exist
        if (!dealCategoryTabData || dealCategoryTabData.length === 0) {
          setDealCategoryTabData(contentCateGoryList);
        }
        setDealData((state) => pageNo === 1 ? newDeals : [...(state || []), ...newDeals]);
        setDealCoupon((state) => pageNo === 1 ? newCoupons : [...(state || []), ...newCoupons]);
        setDealFilter(response?.payload?.data?.response?.filteredDeals);
        setDealCategory(response?.payload?.data?.response?.dealCategories);
        setDealFreq(response?.payload?.data?.response?.dealCoupounFrequencies);
        setTotalRecord(response?.payload?.data?.response?.totalRecords);
        setIsFetching(false);
        // Check if more data is available
        const totalLoaded = (pageNo === 1 ? newDeals.length : ((dealData?.length || 0) + newDeals.length));
        const noMoreData = newDeals.length === 0 || totalLoaded >= response?.payload?.data?.response?.totalRecords;
        setHasMore(!noMoreData);
        setSearchLoader(false);
        setCompLoader(false);
        observerLockRef.current = false;
        setFiltering(false); // Always reset filtering after data load
      });
      setIsModalOpenoffer(false);
    }
    // Depends on loginAuthData?.closeLoader, not the loginAuthData object itself or its
    // isLoading field. This page can't even mount until Auth.js has already set closeLoader
    // true (see Auth.js's own render gate) and nothing ever resets it back to false afterwards
    // — so as a dependency it's already true on this effect's very first run and simply never
    // changes again, meaning login state can only ever trigger this effect once.
    // isLoading, by contrast, still legitimately flips true during the bootstrap's
    // submit/success cycle and back to false again — close enough to mount time that this
    // effect would catch both the false-before and false-after as two separate dependency
    // changes and fetch twice. And depending on the whole loginAuthData object was worse still:
    // any unrelated change to that Redux slice re-ran this fetch too, notably Auth.js's own
    // onLoginAuthReset() cleanup dispatched right after every successful app bootstrap, which
    // creates a new object reference without changing anything this effect actually reads.
    // eslint-disable-next-line
  }, [appliedFilters, loginAuthData?.closeLoader, sectionId, pageNo, searchClicked, activeCate, active, offerSubTypeLabel]);

  const handleDealCoupon = (deal, index) => {
    // Always go to the merchant page now — mobile used to open the inline CouponModal
    // instead, but that's replaced so both viewports land on the same merchant page.
    const dealCoupons = dealCouponData?.filter(
      (coupon) => coupon?.dealId === deal?.id
    );
    dispatch(dataFromDealPage({
      dealData: deal,
      dealCouponData: dealCoupons
    }));
    navigate(`/Offers?did=${encryptAES(String(deal?.id))}`);
    trackEvent("select_offer_card", {
      section_title: sectionId ? sectionData[0]?.sectionName : "Offers",
      image_url: `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal?.mobImage}`,
      page_type: window.location.pathname?.split("/")?.[1],
      brand_name: deal?.name,
      item_position: index + 1,
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });
  };


  const handleDealCouponWeb = (deal, index) => {
    const dealCoupons = dealCouponData?.filter(
      (coupon) => coupon?.dealId === deal?.id
    );

    dispatch(dataFromDealPage({
      dealData: deal,
      dealCouponData: dealCoupons
    }));
    trackEvent("select_offer_card", {
      section_title: sectionId ? sectionData[0]?.sectionName : "Offers",
      image_url: `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal?.mobImage}`,
      page_type: window.location.pathname?.split("/")?.[1],
      brand_name: deal?.name,
      item_position: index + 1,
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });
  };

  useEffect(() => {
    const handleBodyOverflow = () => {
      const isOpen = isModalOpenoffer || isModalOpen;
      document.body.style.overflow = isOpen ? "hidden" : "auto";
    };

    handleBodyOverflow();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpenoffer, isModalOpen]);
  const getSection = (sectionData) => {
    switch (sectionData?.sectionType) {
      case sectionData?.isOfferListPage ? "Supporting Banner" : false:
        if (ShouldShowSection(sectionData, login, isMobileView)) {
          return (
            <>
              {isMobileView ?
                <TopOfferBanner
                  isFullWidth={sectionData?.isFullWidth}
                  isOfferListPage={sectionData?.isOfferListPage}
                  sectionId={sectionData?.id}
                  setShowModal={setShowModal}
                  login={Login}
                  setIsLoading={setIsLoading}
                  sectionData={sectionData}
                  setIsSupportBanner={setIsSupportBanner}
                  isMobileView={isMobileView} />
                : <WebTopOfferBanner
                  isFullWidth={sectionData?.isFullWidth}
                  isOfferListPage={sectionData?.isOfferListPage}
                  sectionId={sectionData?.id}
                  setShowModal={setShowModal}
                  login={Login}
                  setIsLoading={setIsLoading}
                  sectionData={sectionData}
                  setIsSupportBanner={setIsSupportBanner}
                  isMobileView={isMobileView}
                />}
            </>
          );
        }
        return null;
      default:
        return null;
    }
  };

  const handleSearch = () => {
    setSearchClicked(!searchClicked);
    setIsFocused(false);
    setSearchLoader(true);
    if (!searchText.trim()) {
      handleClearSearch();
      return;
    }
    const params = new URLSearchParams(window.location.search);
    // add / update search param
    params.set("search", searchText.trim());
    const destinationUrl = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    // reset pagination
    setPageNo(1);
    trackEvent("search_interaction", {
      search_term_entered: searchText,
      page_type: window.location.pathname?.split("/")?.[1],
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName,
      destination_url: destinationUrl
    });
    // update URL without reload
    navigate(`${window.location.pathname}?${params.toString()}`, {
      replace: true,
    });

  };

  const handleClearSearch = () => {
    setSearchClicked(!searchClicked);
    setIsFocused(true);
    setSearchLoader(true);
    // clear input state
    setSearchText("");
    const params = new URLSearchParams(window.location.search);
    // remove search param from URL
    params.delete("search");
    // reset pagination
    setPageNo(1);
    // update URL
    const queryString = params.toString();
    navigate(
      queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname,
      { replace: true }
    );
  };

  const getNextTabUrl = (tab) => {
    const nextUrl = new URL(window.location.href);
    const isOfferSubTypeTab =
      tab?.contentSourceType === offerSubTypeLabel &&
      tab?.sourceValue;

    if (isOfferSubTypeTab) {
      nextUrl.searchParams.delete("category");
      nextUrl.searchParams.delete("sourceType");
      nextUrl.searchParams.delete("sourceValue");
      nextUrl.searchParams.set("offer", String(tab?.sourceValue).toUpperCase());
    } else {
      nextUrl.searchParams.delete("offer");
      nextUrl.searchParams.set("category", getTabCategoryValue(tab));

      if (tab?.contentSourceType && tab?.sourceValue) {
        nextUrl.searchParams.set("sourceType", tab.contentSourceType);
        nextUrl.searchParams.set("sourceValue", String(tab.sourceValue));
      } else {
        nextUrl.searchParams.delete("sourceType");
        nextUrl.searchParams.delete("sourceValue");
      }
    }

    return nextUrl.toString();
  };

  const filterClickGAEventTracker = (tab) => {
    const nextUrl = getNextTabUrl(tab);
    trackEvent("navigation_interaction", {
      cta_text: tab?.value,
      page_url: window.location.pathname,
      page_type: window.location.pathname?.split("/")?.[1],
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      destination_url: nextUrl,
      card_name: defaultCardName
    });
  }
  return (
    <>
      <Helmet>
        <title>{translation?.dealTitle}</title>
        <meta
          name="description"
          content={translation?.dealDescription}
        />
      </Helmet>
      <ScrollToTop />
      <>
        {isLoading || isSectionLoading || isFetching ? (
          <OfferLoader />
        ) : (
          <>
            <div
              id="top_offer_main_wrapper_container"
              className="top_offer_main_wrapper_container container mx-auto"
            >
              <div className="row ">
                {isMobileView ? (
                  <>
                    <CustomBackHeader
                      customClass="offer_title1 mobile_heading sticky top-0 z-10 bg-white"
                      title={sectionId ? sectionData[0]?.sectionName : "Offers"}
                      backBtnRef={backBtnRef}
                    />
                  </>
                ) : (
                  <>
                    {" "}
                    <div>
                      {sectionMasterData?.map((sectionData, index) => (
                        <div id={`SEC_${sectionData?.id}`} key={index}>
                          {getSection(sectionData, Login)}
                        </div>
                      ))}
                    </div>
                    <div className={`pl-6 pr-6 ${isSupportBanner ? 'mt-1' : 'mt-4'}`}>
                      <div className="relative w-full">
                        <input
                          ref={searchInputRef}
                          name="search"
                          type="text"
                          className="offer-search-input"
                          placeholder="Search by brand, offer, etc."
                          value={searchText || ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only letters & numbers
                            if (/^[a-zA-Z0-9\s]*$/.test(value)) {
                              if (value.trim() === "" && prevSearchTextRef.current.trim() !== "") {
                                handleClearSearch();
                              } else {
                                setSearchText(value);
                              }
                              prevSearchTextRef.current = value;
                            }
                          }}
                          onFocus={() => setIsFocused(true)}
                          onBlur={() => setIsFocused(false)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && searchText.trim()) {
                              handleSearch();
                            }
                          }}
                        />
                        {/* 🔍 Search icon (default & focused) */}
                        {(isFocused || !searchText) && (
                          <img
                            src={searchIcon}
                            alt="search"
                            className={`absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 z-10 ${!searchText.trim() ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onMouseDown={searchText.trim() ? handleSearch : undefined}
                          />
                        )}

                        {/* ❌ Clear icon — ONLY when not focused AND text exists */}
                        {!isFocused && searchText && (
                          <button
                            type="button"
                            className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 z-10"
                            onClick={handleClearSearch}
                          >
                            <i className="fas fa-times serach-clear-icon"></i>
                          </button>
                        )}
                      </div>
                      {!sectionId && dealCategoryTabData?.length > 0 && <div style={{ width: '100%', gap: '20px' }}>
                        <div className="tab-offer-wrapper">
                          <div className="tab-offer-bar-wrapper">
                            <div className="tab-offer-bar-width"></div>
                            <div className="tab-offer-bar" ref={tabBarRef}>
                              {dealCategoryTabData.map((tab) => (
                                <button
                                  key={tab?.key}
                                  className={`tab-offer ${active === tab?.value ? "active" : ""}`}
                                  onClick={(e) => {
                                    setIsFilterFlowActive(false);
                                    setSearchLoader(true);
                                    setPageNo(1);
                                    setActive(tab?.value);
                                    setActiveCate(tab?.key);
                                    setTemporaryFilters((prev) => ({ ...prev, category: [] }));
                                    setTagFilters((prev) => ({ ...prev, category: [] }));
                                    setAppliedFilters((prev) => ({ ...prev, category: [] }));
                                    e.currentTarget.scrollIntoView({
                                      behavior: "smooth",
                                      inline: "center",
                                      block: "nearest",
                                    });
                                    filterClickGAEventTracker(tab);
                                    setActiveTab("Validity");
                                  }}
                                >
                                  <React.Fragment>
                                    {tab?.webImage && <img
                                      src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${active === tab?.value ? tab.mobImage : tab.webImage}`}
                                      alt="not-found"
                                      height="40px"
                                      width="40px"
                                    />}
                                  </React.Fragment>
                                  <h3 className={`${active === tab?.value ? "active-text" : "non-active-text"}`}>{tab?.value}</h3>
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="tab-divider" />
                      </div>}
                      <div className="pt-5 pb-2">
                        <OfferTabFilters
                          tabs={offerTabFilterTabs}
                          activeTabs={appliedFilters?.offer || []}
                          onTabClick={handleOfferTabClick}
                          filterCount={appliedFilters?.brand?.length + visibleCategoryAppliedFilters?.length + appliedFilters?.validity?.length + appliedFilters?.offer?.length}
                          onFilterClick={() => setIsModalOpen(true)}
                          filterIconUrl={filterIconUrl}
                        />
                      </div>
                      {/* <div className="flex items-center space-x-4 relative filter-row pt-4">
                        <div className="flex items-center space-x-2 relative filter-col">
                          <span onClick={() => setIsModalOpen(true)}>
                            {translation?.filter}
                          </span>
                          <div className="relative inline-block">
                            <img
                              className="h-4 w-4 cursor-pointer"
                              src={filter}
                              alt="filterImg"
                              onClick={() => setIsModalOpen(true)}
                            />
                            {tagFilters?.brand?.length ||
                              visibleCategoryTagFilters?.length > 0 ||
                              tagFilters?.offer?.length > 0 ||
                              tagFilters?.validity?.length ? (
                              <span className="notification-dot"></span>
                            ) : null}
                          </div>
                        </div>
                        {(appliedFilters?.brand?.length > 0 || visibleCategoryAppliedFilters?.length > 0 || appliedFilters?.validity?.length > 0 || appliedFilters?.offer.length > 0) && (
                          <SelectedBrand
                            setActiveTab={setActiveTab}
                            setIsModalOpen={setIsModalOpen}
                            tagFilters={tagFilters}
                            hiddenCategoryValues={hiddenCategoryChipValues}
                            setTagFilters={setTagFilters}
                            setAppliedFilters={applyFilter}
                            isMobileView={isMobileView}
                            setPageNo={setPageNo}
                            setIsFetching={setIsFetching}
                          />
                        )}

                      </div> */}
                    </div>
                  </>
                )}
                {isMobileView && (<>
                  {" "}
                  <div>
                    {sectionMasterData?.map((sectionData, index) => (
                      <div id={`SEC_${sectionData?.id}`} key={index}>
                        {getSection(sectionData, Login)}
                      </div>
                    ))}
                  </div>
                  <div className={`pl-6 pr-6 ${isSupportBanner ? 'mt-1' : 'mt-4'} flex items-center gap-2`}>
                    <div className="relative w-full">
                      <input
                        ref={searchInputRef}
                        type="text"
                        className="offer-search-input"
                        placeholder="Search by brand, offer, etc."
                        value={searchText || ''}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow only letters & numbers
                          if (/^[a-zA-Z0-9\s]*$/.test(value)) {
                            if (value.trim() === "" && prevSearchTextRef.current.trim() !== "") {
                              handleClearSearch();
                            } else {
                              setSearchText(value);
                            }
                            prevSearchTextRef.current = value;
                          }
                        }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && searchText.trim()) {
                            handleSearch();
                          }
                        }}
                      />
                      {/* 🔍 Search icon (default & focused) */}
                      {(isFocused || !searchText) && (
                        <img
                          src={searchIcon}
                          alt="search"
                          className={`absolute serach-mobile-icon right-3 top-1/2 -translate-y-1/2 w-5 h-5 z-10 ${!searchText.trim() ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                          onMouseDown={searchText.trim() ? handleSearch : undefined}
                        />
                      )}

                      {/* ❌ Clear icon — ONLY when not focused AND text exists */}
                      {!isFocused && searchText && (
                        <button
                          type="button"
                          className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 z-10"
                          onClick={handleClearSearch}
                        >
                          <i className="fas fa-times serach-clear-icon"></i>
                        </button>
                      )}
                    </div>
                    {/* {tagFilters?.brand?.length ||
                      visibleCategoryTagFilters?.length > 0 ||
                      tagFilters?.offer?.length > 0 ||
                      tagFilters?.validity?.length ? (
                      <span className="notification-dot"></span>
                    ) : (
                      <span className="without-filt"></span>
                    )} */}
                    {/* <div className="hide_desktop filter-wrapper" onClick={() => setIsModalOpen(true)}>
                      <img
                        className="img-filter"
                        src={filter}
                        alt="filterImg"
                      />
                    </div> */}
                  </div>
                </>
                )}
                {!sectionId && isMobileView && dealCategoryTabData?.length > 0 && <div style={{ width: '100%', gap: '20px' }}>
                  <div className="tab-offer-wrapper">
                    <div className="tab-offer-bar" ref={tabBarRef}>
                      {dealCategoryTabData.map((tab) => (
                        <button
                          key={tab?.key}
                          className={`tab-offer ${active === tab?.value ? "active" : ""}`}
                          onClick={(e) => {
                            setIsFilterFlowActive(false);
                            setSearchLoader(true);
                            setPageNo(1);
                            setActive(tab?.value);
                            setActiveCate(tab?.key);
                            setTemporaryFilters((prev) => ({ ...prev, category: [] }));
                            setTagFilters((prev) => ({ ...prev, category: [] }));
                            setAppliedFilters((prev) => ({ ...prev, category: [] }));
                            e.currentTarget.scrollIntoView({
                              behavior: "smooth",
                              inline: "center",
                              block: "nearest",
                            });
                            filterClickGAEventTracker(tab);
                            setActiveTab("Validity");
                          }}

                        >
                          <React.Fragment>
                            {tab?.webImage && <img
                              src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${active === tab?.value ? tab.mobImage : tab.webImage}`}
                              alt="not-found"
                              height="24px"
                              width="24px"
                            />}
                          </React.Fragment>
                          <h3 className={`${active === tab?.value ? "active-text" : "non-active-text"}`}>{tab?.value}</h3>
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="tab-divider" />
                </div>}
                {isModalOpen && (
                  <FilterModal
                    dealCouponFilter={dealCouponData}
                    commonDeals={dealsFilter}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    onClose={() => setIsModalOpen(false)}
                    setAppliedFilters={applyFilter}
                    appliedFilters={appliedFilters}
                    setTagFilters={setTagFilters}
                    setIsModalOpen={setIsModalOpen}
                    tagFilters={tagFilters}
                    temporaryFilters={temporaryFilters}
                    setTemporaryFilters={setTemporaryFilters}
                    dealCategoryData={dealCategoryData}
                    setIsFetching={setIsFetching}
                  />
                )}{" "}
                <div
                  className={`col-lg-8 col-md-8 col-sm-8 col-12 top_offer_content_wrapper ${(tagFilters.validity.length > 0 ||
                    visibleTagFilters.category.length > 0 ||
                    tagFilters.brand.length > 0) &&
                    !isMobileView
                    ? ""
                    : ""
                    }`}
                >
                  {isMobileView &&
                    <div className="pl-4 pt-3 pb-2 pr-4">
                      <OfferTabFilters
                        tabs={offerTabFilterTabs}
                        activeTabs={appliedFilters?.offer || []}
                        onTabClick={handleOfferTabClick}
                        filterCount={appliedFilters?.brand?.length + visibleCategoryAppliedFilters?.length + appliedFilters?.validity?.length + appliedFilters?.offer?.length}
                        onFilterClick={() => setIsModalOpen(true)}
                        filterIconUrl={filterIconUrl}
                      />
                    </div>
                    // (appliedFilters?.brand?.length > 0 || visibleCategoryAppliedFilters?.length > 0 || appliedFilters?.validity?.length > 0 || appliedFilters?.offer.length > 0) && (
                    //   <div className="px-4">
                    //     <SelectedBrand
                    //       setActiveTab={setActiveTab}
                    //       setIsModalOpen={setIsModalOpen}
                    //       tagFilters={tagFilters}
                    //       hiddenCategoryValues={hiddenCategoryChipValues}
                    //       setTagFilters={setTagFilters}
                    //       setAppliedFilters={applyFilter}
                    //       isMobileView={isMobileView}
                    //       setPageNo={setPageNo}
                    //       setIsFetching={setIsFetching}
                    //     />
                    //   </div>
                    // )
                  }
                  <div
                    className={
                      dealData?.length
                        ? isMobileView
                          ? " mt-4 pl-4 pr-4"
                          : " mt-6 pl-6 pr-6"
                        : ""
                    }
                  >
                    {searchLoader && !comLoader && <CardLoader />}
                    {!searchLoader && dealData?.length > 0 ? <>
                      <div className="coupoun-grid-view-wrapper">
                        {
                          dealData.map((deal, index) => {
                            const coupon = dealCouponData?.filter(
                              (dealCoupon) => dealCoupon?.dealId === deal?.id
                            );
                            const isFeature = dealCouponData?.filter(
                              (dealCoupon) =>
                                dealCoupon?.dealId === deal?.id &&
                                dealCoupon?.offerType === translation?.feature
                            ).length;
                            return (
                              <React.Fragment key={deal.id || index}>
                                {isMobileView ? (
                                  <>
                                    {/* <CommonMobileOffer
                                  index={index}
                                  handleDealCoupon={(deal) => handleDealCoupon(deal, index)}
                                  deal={deal}
                                  bgImg={bgImg}
                                  matchingCoupon={coupon}
                                  isFeature={isFeature}
                                  clientCode={clientData?.[0]?.clientCode}
                                  couponCount={dealCouponData?.filter(
                                    (coupon) => coupon?.dealId === deal?.id
                                  )}
                                /> */}
                                    {/* <div className="flex justify-center mobile-offer-card-slot"> */}
                                    <CommonOffer
                                      index={index}
                                      handleDealCoupon={() => handleDealCoupon(deal, index)}
                                      deal={deal}
                                      bgImg={bgImg}
                                      key={deal?.id}
                                      matchingCoupon={coupon}
                                      isFeature={isFeature}
                                      couponCount={dealCouponData?.filter(
                                        (coupon) => coupon?.dealId === deal?.id
                                      )}
                                      isMobileView={isMobileView}
                                    />
                                    {/* </div> */}
                                  </>
                                ) : (
                                  <>
                                    {/* <CommonWebOffer
                                    matchingCoupon={coupon}
                                    offer={deal}
                                    index={index}
                                    page={true}
                                    dealCouponFilter={dealCouponData}
                                    handleDealCouponWeb={(deal) => handleDealCouponWeb(deal, index)}
                                  /> */}
                                    {/* <div className="flex justify-center"> */}
                                    <CommonOffer
                                      index={index}
                                      handleDealCoupon={() => handleDealCouponWeb(deal, index)}
                                      deal={deal}
                                      bgImg={bgImg}
                                      key={deal?.id}
                                      matchingCoupon={coupon}
                                      isFeature={isFeature}
                                      couponCount={dealCouponData?.filter(
                                        (coupon) => coupon?.dealId === deal?.id
                                      )}
                                      isMobileView={isMobileView}
                                    />
                                    {/* </div> */}
                                  </>
                                )}
                              </React.Fragment>
                            );
                          })
                        }
                      </div>
                    </>
                      : searchLoader ? <></> : (
                        <div className="pt-5">
                          <NoRecord />
                        </div>
                      )}

                    {/* Loader shown at the end, only when fetching more */}
                    <div ref={loaderRef} className="infinite-loader-wrapper">
                      {comLoader && hasMore && <CardLoader />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {isModalOpenoffer && (
          <CouponModal
            onCouponClose={() => setIsModalOpenoffer(false)}
            couponData={dealsData?.dealCoupon}
            dealImage={dealsData?.deal}
            isMobileView={isMobileView}
            sectionTitle={sectionId ? sectionData[0]?.sectionName : "Offers"}
          />
        )}
      </>
    </>
  );
};

export default TopOfferPage;